import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobSelection',
    props: {
        jobId: null,
        implicitCollectionJobsId: null,
        selectJobOptions: null,
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        function handleInput(value) {
            emit("input", value);
        }
        return { __sfc: true, emit, handleInput };
    }
});
